import React, { Component } from 'react'
import soundOn from '../assets/images/sound_on.png';
import soundOff from '../assets/images/sound_off.png';

export default class AudioBtn extends Component {
    
    backgroundMusic = './sounds/background_music.mp3';
    bgMusicAudio = null;
    playing = false;

    constructor(props) {
        super(props);
        this.state = {
            mute: true
        };
    }

    componentDidMount() {
        this.playMusic()
    }

    switchSoundOnOff() {
        this.setState({
            mute: !this.state.mute
        });
        // this.bgMusicAudio.muted = this.state.mute;
        this.bgMusicAudio.volume = this.state.mute ? 0.3 : 0.0;
        if (!this.playing) {
            this.bgMusicAudio.play();
            this.playing = true;
            console.log('play background music')
        }
    }

    playMusic() {
        if (this.bgMusicAudio === null) {
            this.bgMusicAudio = new Audio(this.backgroundMusic);
        }
        this.bgMusicAudio.volume = 0.3;
        this.bgMusicAudio.loop = true;
        console.log('load music completed')
    }
    
    render() {
        return (
            <div className='unselectable' style={{ width: '10%', position: 'absolute', left: '1vmin', bottom: '1vmin' }}>
                <img alt='' style={{ width: '100%' }} src={this.state.mute ? soundOff : soundOn} onClick={this.switchSoundOnOff.bind(this)}></img>
                {/* <audio id='bg_music' ref='backgroundMusic' muted={this.state.mute} src={this.backgroundMusic} autoPlay={true} loop={true}></audio> */}
            </div>
        )
    }
}